module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "clientesmain"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "left",
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "titles-cont"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.title)
    }
  }, [_c('hr')]), _vm._v(" "), _c('h1', {
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v(_vm._s(_vm.state.subTitle))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "pcont",
    domProps: {
      "innerHTML": _vm._s(_vm.state.clientTxt)
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 footer-container",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contacto",
      "tag": "a"
    }
  }, [_c('h3', [_vm._v(_vm._s(this.$store.state.activeList.footerPage.title))])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "1px solid white"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Copy right @2017 - All Rights Reserved")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 img-cont"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/imgs/clientes_foto1.png"),
      "width": "90%",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 client-icon-cont"
  }, [_c('div', {
    staticClass: "clientes-container",
    staticStyle: {
      "margin-top": "300px"
    }
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_alen_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_cemenquin_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_fevisa_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_jumex_blanco.png")
    }
  }), _vm._v("   \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "clientes-container"
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logos_azteca_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_maseca_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_pazher_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_psf_blanco.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientes-container",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_sunpower_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_vitro_blanco.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "data-aos": "zoom-in",
      "src": require("../../assets/logos/logo_zahori_blanco.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490be8ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientes/clientes.vue
// module id = 146
// module chunks = 0